import { motion } from "framer-motion";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
    {
        q: "HGS ve otoyol maliyetleri güncel mi?",
        a: "Evet. Uygulama güncel tarife verilerini kullanır; değişen ücretler sık aralıklarla yenilenir. Farklı araç sınıfları için tutar otomatik hesaplanır.",
    },
    {
        q: "Yakıt tahmini nasıl yapılıyor?",
        a: "Araç tipi, yakıt türü ve ortalama tüketim değerleri baz alınarak güzergâh uzunluğu üzerinden hesaplanır. Tutar, en güncel akaryakıt fiyatlarıyla anlık olarak güncellenir.",
    },
    {
        q: "Çevrimdışı çalışır mı?",
        a: "Önceden planlanan rotalar cihazda saklanır; zayıf ağ koşullarında da özet bilgileri görebilirsin. Harita karoları için internet bağlantısı önerilir.",
    },
    {
        q: "Mola yerleri hangi kategorilerde?",
        a: "Restoran, mescit, tuvalet ve oto yıkama başta olmak üzere yolcu deneyimine odaklı kategoriler. Filtreleri kombinleyerek kendi molanı özelleştirebilirsin.",
    },
];

export default function FAQ() {
    return (
        <section
            id="sss"
            data-testid="faq-section"
            className="relative py-28 sm:py-36 px-5 sm:px-8 max-w-4xl mx-auto"
        >
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.7 }}
                className="mb-14 text-center"
            >
                <div className="text-[#00F0FF] text-xs uppercase tracking-[0.22em] font-medium mb-5">
                    Sıkça sorulanlar
                </div>
                <h2 className="font-display font-semibold text-4xl sm:text-5xl leading-[1.02] tracking-tight">
                    Aklında soru mu var?
                </h2>
                <p className="mt-4 text-white/55 text-base max-w-lg mx-auto">
                    Cevabı yoksa bize yaz; hemen ekleyelim.
                </p>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.7, delay: 0.1 }}
            >
                <Accordion type="single" collapsible className="w-full space-y-3" data-testid="faq-accordion">
                    {faqs.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            data-testid={`faq-item-${i}`}
                            className="rounded-2xl bg-[#111115] border border-white/[0.06] px-5 !border-b"
                        >
                            <AccordionTrigger className="font-display font-medium text-base text-white hover:no-underline hover:text-[#00F0FF] transition-colors py-5">
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-white/60 text-sm leading-relaxed pb-5">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </motion.div>
        </section>
    );
}
